import { Box, type BoxProps } from '@frontend/legacy-components';

export type ConfigItemListPageWrapperProps = BoxProps;

const ConfigItemListPageWrapper = (props: ConfigItemListPageWrapperProps) => (
  <Box
    height="100%"
    sx={{
      scrollbarGutter: 'stable',
    }}
    overflowX="hidden"
    overflowY="auto"
    backgroundColor="page.background"
    {...props}
  />
);

export default ConfigItemListPageWrapper;
